import { api, apiTest } from './config'
import { getToken, setToken, removeToken } from '../store/auth'
import request from './request'
var sha1 = require('sha1')

export default {
  administradorDesenvolvimento: { 

    retornarTituloHelp () {
      return request({
        url: 'administradorDev/retornarTituloHelp/',
        method: 'get'
      })
    },

    alterarTituloHelp (titulo, idTituloHelp) {
      var obj = {
        titulo: titulo,
        idTituloHelp: idTituloHelp
      }
      return request({
        url: '/administradorDev/alterarTituloHelp/',
        method: 'post',
        data: obj
      })
    },

    cadastrarTituloHelp (titulo) {
      var obj = {
        titulo: titulo
      }
      return request({
        url: '/administradorDev/cadastrarTituloHelp/',
        method: 'post',
        data: obj
      })
    },

    cadastrarHelp (idTituloHelp, subtitulo, texto, tipo) {
      var obj = {
        idTituloHelp: idTituloHelp,
        subtitulo: subtitulo,
        texto: texto,
        tipo: tipo
      }
      return request({
        url: '/administradorDev/cadastrarHelp/',
        method: 'post',
        data: obj
      })
    },

    alterarHelp (idTituloHelp, subtitulo, texto, idHelp) {
      var obj = {
        idTituloHelp: idTituloHelp,
        subtitulo: subtitulo,
        texto: texto,
        idHelp: idHelp
      }
      return request({
        url: '/administradorDev/alterarHelp/',
        method: 'post',
        data: obj
      })
    },

    deletarHelp (idHelp) {
      var obj = {
        idHelp: idHelp
      }
      return request({
        url: '/administradorDev/removerHelp/',
        method: 'post',
        data: obj
      })
    },

    retornarHelp (tipo) {
      return request({
        url: `/administradorDev/retornarHelp/${tipo}`,
        method: 'get'
      })
    },

    mensagem (text, context, botparams) {
      // return api.get('/retornarServicos/'+id)
      console.log('imprind')

      var dadosMensagem = {
        msg: text,
        context: context,
        botparams: botparams
      }
      var obj = {
        dadoMensagem: dadosMensagem
      }
      console.log('aquiiiiiiiiiii', obj)
      // return api.post('administradorUnidade/alterarLocal/',obj)
      return request({
        url: 'administradorDev/mensagem/',
        method: 'post',
        data: obj
      })
    },

    retornarVideos () {
      // return api.get('/retornarServicos/'+id)
      return request({
        url: 'administradorDev/retornarVideos/',
        method: 'get'
      })
    },

    cadastrarVideo (nome, link) {
      var obj = {
        nome: nome,
        link: link
      }
      // return api.post('administradorUnidade/alterarLocal/',obj)
      return request({
        url: 'administradorDev/cadastrarVideo/',
        method: 'post',
        data: obj
      })
    },
    alterarVideo (idVideo, nome, link) {
      var obj = {
        idVideo: idVideo,
        nome: nome,
        link: link
      }
      // return api.post('administradorUnidade/alterarLocal/',obj)
      return request({
        url: 'administradorDev/alterarVideo/',
        method: 'post',
        data: obj
      })
    }

  }
}
